import { forEach, includes, keys, map, orderBy } from 'lodash'
import { BehaviorSubject, Subject } from 'rxjs'
import { getVideoShareLink, getVideoURL } from '../Constants'
import { Point } from '../Models/PIPModesl.interface'
import {VideoWatchRecord, VideoModel, WatchList} from '../Models/Video.interface'
import { Database } from './DataManager'
import { Playback } from '../Models/Playback.interface'
import Storage from './Storage'
// import { Share } from 'react-native';
import { ProgramModel } from '../Models/Program.interface'
import _ from 'lodash'

const watchlistPreamble = 'watchlist-';
const historyWatchlist = {
    name: 'history',
    id: '11330history' ,
    created_at: 0,
    updated_at: 0,
} as WatchList
const continueWatchingList = {
    name: 'continueWatchingList',
    id: '123kf0193continuewatching' ,
    created_at: 0,
    updated_at: 0,
} as WatchList

const RECORDS = "RECORDS"


const watchlists = 'watchlistnames'


export type VideoContextData =  {
    currentVideo: VideoModel,
    url: string
}


class VideoManagement{
    private url = new BehaviorSubject<string>(null)
    private controlVisibility = new BehaviorSubject(0)
    private currentCorner: Point;
    private pipState: number = 0
    private showSeekBar: boolean = true
    private playback = new BehaviorSubject({} as Playback)
    private pipRequest = new Subject()
    private pipObserver = new BehaviorSubject(0)
    private seekRequest = new Subject()
    private watchHistory = new BehaviorSubject<Array<VideoWatchRecord>>([])
    private continueWatching = new BehaviorSubject<Array<VideoWatchRecord>>([])
    private currentVideo = new BehaviorSubject<VideoModel | null>(null)
    private timeRequest = new BehaviorSubject<number | null>(null)
    private locationChange = new BehaviorSubject<string | null>(null)

    getURL = () => this.url.asObservable()
    getControlVisibility = () => this.controlVisibility.asObservable()
    getPIPRequest = () => this.pipRequest.asObservable()
    getPIPObservation = () => this.pipObserver.asObservable()
    getSeekRequest = () => this.seekRequest.asObservable()
    getPlayback = () => this.playback.asObservable()
    getCurrentVideo = () => this.currentVideo.asObservable()
    getTimeRequest = () => this.timeRequest.asObservable()
    getLocationChange = () => this.locationChange.asObservable()
    getTimeRequestSnapshot = () => this.timeRequest?.value
    setVideo = async (video: VideoModel, time: number = 0) => {
        this._prepForNewURL()
        console.log(video)
        if(video?.video){
            this.locationChange.next(`/watch/${video?.uuid}`)
            this.url.next(video.video)
            this.currentVideo.next(video)

            // update stats by asking for video anyway and
            // ignore the response
            Database.getVideo(getVideoURL(video?.uuid || ""))
        }


        if(!!time && time > 0){
            this.timeRequest.next(time)
        }

    }

    hasVideo = () => this.pipState !== 0

    setVideoAsLivestream = async () => {
        this._prepForNewURL()
        let url = await Database.getLiveStream()
        console.log(url)
        this.showSeekBar = false
        this.url.next(url)
    }

    getSeekBarVisibility = () => this.showSeekBar

    setPIPState = (state) => {
        this.pipState = state
        this.pipObserver.next(state)
    }

    requestPIPState = (state)=> {
        this.pipRequest.next(state)
    }

    getPIPState = () => this.pipState 

    updateVideoHistory =  async () => {
        const video = this.currentVideo.value
        if(!video){
            return
        }
        const playback = this.getPlaybackSnapshot()
        const time = playback.currentTime
        const total = playback.seekableDuration
        // console.log("UPDATE", time, total, playback)
        return this.addVideoToHistory(video, time, total)
    }
    clearVideo = async () => {
        try{
           await  this.updateVideoHistory()
        } catch(e) {
            console.log(e)
        }
        this.timeRequest.next(0)
        this.url.next(null)
        this.pipState = 0
        this.pipObserver.next(0)
        this.showSeekBar = true
        this.playback.next({} as Playback)
    }

    _prepForNewURL = async () => {
        this.url.next(null)
    }

    setTargetCorner = (corner: Point) => {
        this.currentCorner = corner
    }


    getTargetCorner = () => this.currentCorner

    timeout;
    flashControls = () => {
        // console.log('flashing')
        if(this.timeout){
            clearTimeout(this.timeout)
        }
        this.controlVisibility.next(1)
        this.timeout = setTimeout(() => {
            this.controlVisibility.next(0)
            clearTimeout(this.timeout)
        }
            , 5000)
    }

    updatePlayback = (value: Playback) => {
        // console.log(value )
        this.playback.next(value)

    }

    requestSeek = (value: number) => {
        // check whether seek is posible
        if(this.playback?.value?.seekableDuration >= value){
            this.seekRequest.next(value)
        } 
    }

    getPlaybackSnapshot = () => {
        const snap = this.playback.value
        return snap
    }

    addVideoToHistory = async (video: VideoModel, time: number = 0, total: number = -1) => {
        try{
            let record = {
                video,
                time,
                total,
                id: video.id ,
                updated_at: new Date().getTime(),
                watched_at: new Date().getTime(),
            } as VideoWatchRecord

            if(total === -1){
                // only update total when there is a value other than 0
                delete record.total   
            }
            // console.log("Record from add", record)
             this.addToHistory(record) 
        } catch(e) {
            console.log(e)
            return Promise.reject(e)
        }
    }

    addToHistory = async (record: VideoWatchRecord) => {

        try{
            await this._setVideoInStorage(record)
            this.addToWatchList(record, historyWatchlist.id)

            .catch(console.log)
            if(!!record.total && record.time < (record.total - 15) ){
                // console.log("Adding to Continue Watching")
                this.addToWatchList(record, continueWatchingList.id)
                .catch(console.log)
            } else {
                // we have a video that has finished and 
                // since we're done watching it, remove
                // it from continueWatchinglist
                // console.log("Removing From Continue Watching")
                this.removeFromWatchList(record, continueWatchingList.id)
                    .catch(console.log)

                 
            } 

            this.reloadVideos()
            return 
        } catch(e) {
            console.log(e)
            return Promise.reject(e)
        }
    }

    reloadVideos = async () => {
        const history_ids = await Storage.get(watchlistPreamble +  historyWatchlist.id)
        const cw_ids = await Storage.get(watchlistPreamble + continueWatchingList.id)
        // console.log(history_ids, cw_ids)
        const vids = await Storage.get(RECORDS)
        let cw:Array<VideoWatchRecord> = []
        let history:Array<VideoWatchRecord> = []
        _.forEach(history_ids, id => {
            history.push(vids[id])
        })
        _.forEach(cw_ids, id => {
            cw.push(vids[id])
        })
        // console.log(history, cw)
        history = this._sort(history)
        cw = this._sort(cw)

        this.watchHistory.next(history)
        this.continueWatching.next(cw)



    }

    addToWatchList = async (record: VideoWatchRecord, watchlist_id: string) => {
        try{            
            let updatedList = await Storage.updateArrayWithID(watchlistPreamble + watchlist_id, record.id, this._sort)
            // console.log("Storage => ", updatedList)
            return updatedList

        } catch(e) {
            console.log(e)
            return Promise.reject("We were unabled to add your video to your list.")
        }
        
        // let watchlist = await Storage.get(watchlistPreamble + watchlist_id)
        // // watchlist is an object?
        // if(!watchlist) {
        //     watchlist = []
        // }

        // watchlist.push(record.id)
        // watchlist = this._sort(watchlist)
        // Storage.set(watchlistPreamble + watchlist_id, watchlist)
        // return watchlist
    }

    // remove a video from a watchlist
    removeFromWatchList = async (record: VideoWatchRecord, watchlist_id: string) => {
        try{
            return Storage.deleteArrayItem(watchlistPreamble + watchlist_id, record.id)
        } catch(e) {
            return Promise.reject('We were unable to remove the video from the watchlist.')
        }
    }

    removeFromHistory  = async (video: VideoWatchRecord) => {
        try{
            let newList = await this.removeFromWatchList(video, historyWatchlist.id)
            this.watchHistory.next(newList)
            return newList
        } catch(e) {
            console.log(e)
            return Promise.reject("Unable to remove video from history. ")
        }
        
        
    }

    removeFromContinueWatching  = async (video: VideoWatchRecord) => {
        const data = await this.removeFromWatchList(video, continueWatchingList.id)
        this.reloadVideos()
        return 
    }

    _convertToArray = (object: Object) =>  map(keys(object), key => object[key])
    
    _sort = (list: Array<VideoWatchRecord>) => orderBy(list, ['watched_at'], ['desc'] )

    getHistory = () => {
        this.reloadVideos()
        return this.watchHistory.asObservable()
    }

    getContinueWatching = () => {
        this.reloadVideos()
        return this.continueWatching.asObservable()
    }

    getWatchlist = async (watchlist_id: string) => {
        try{
            const ids = await Storage.get(watchlistPreamble + watchlist_id)
            // get the video ids from the watchlist
            if(!ids){
                return []
            }
            return this._getVideosFromStorage(ids)
        } catch(e) {
            console.log("Error retrieving watchlist", e)
            return []
        }
    }

    _getVideosFromStorage = async (video_ids: Array<string | number>) => {
        let records = await Storage.get(RECORDS)
        let list = []
        if(!records){
            return []
        } else {
             _.forEach(video_ids, id => {
                 const record = records[String(id)]
                 list.push(record)
             })
             return list
        }
    }

    _setVideoInStorage = async (record: VideoWatchRecord) => {
        try{
            await Storage.updateObject(RECORDS, record, record.id)
            // let records = await Storage.get(RECORDS)
            // records[String(record.id)] = record
            // await Storage.set(RECORDS, records)
            return
        } catch(e) {
            console.log(e)
            return 
        }
        
    }



    // save a new watchlist to the list 
    // of watch lists
    saveWatchListNames = async (watchlist: WatchList) => {
        let names = await Storage.get(watchlists)
        // watchlist is an object?
        if(!names) {
            names = {}
        }
        names[`${watchlist.id}`] = watchlist
        Storage.set(watchlists, names)
    }

    // remove a user created list by id
    removeWatchListBy = async (id: string) => {
        try{
            await Storage.deleteObjectItemById(watchlists, id)
            return 
        } catch(e) {
            return Promise.reject("We were unable to delete your watchlist.  An unknown error occured")
        }
    }

    // remove a user created list 
    removeWatchList = async (watchlist: WatchList) => {
       return this.removeWatchListBy(watchlist.id)
     }

    //  share = (video: VideoModel, program: ProgramModel) => {
    //      // switching to shareById.  See 
    //      // shareByName for details
    //     this.shareById(video.id, program.id)
    //  }


    //  shareById = (vid_id: number, prog_id: number) => {
    //    const url = getVideoShareLink(vid_id, prog_id)
    //    Share.share({
    //        message: url,
    //        url,
    //        title: `I'd like to share this video with you!`
    //    })
    // }
    //  shareByName = (vid_name: string, prog_name: string) => {
    //      // we are not going to use this until we get some
    //      // consistency with the formula.
    //      // in theory, the : character should not be included
    //      // in the url, but on some video (sabbath school lessons 2021 q2 lesson 7: covenant at sinai)
    //      // the : is removed however on other (take-charge-of-your-health/take-charge-of-your-health:-combating-cancer)
    //      // the : remains....
    //      //  moving to shareById
    //     let videoid = this.lower(vid_name)
    //     let programid  = this.lower(prog_name)

    //     const url = getVideoShareLink(videoid, programid)
    //     Share.share({
    //         message: url,
    //         url,
    //         title: `${vid_name}`
    //     })
    //  }
     lower = (word: string) => {
        // replace all apostrophies
       word = word.replace(/[^A-Za-z0-9]/g, ' ');
    //    console.log(word)
       // lower case
       word = word.toLowerCase()
    //    console.log(word)
       // remove leading and trailing whitespace
       // replace any double spaces with one space
       word = word.trim()
       word = word.replace(/[ ]{2,}/g, " ")
       // add in dashes
       word = _.replace(word, / /g, '-')
    //    console.log(word)
       return word
    }

}

const VideoManager = new VideoManagement()
export default VideoManager